<app-sync-status-popup></app-sync-status-popup>
<router-outlet></router-outlet>

